"use client";

import React from "react";
import type { RegionType } from "lib/apollo/types";
import type { FooterItem } from "../Footer.types";
import { footerMenuItem, privacyChoicesLinkStyles } from "./FooterMenuItem.css";

interface Props {
  item: FooterItem;
  region: RegionType;
}

export const CookiePreferenceButton: React.FC<Props> = ({
  item,
  region,
  ...otherProps
}) => {
  return (
    <button
      data-banner-region={region}
      onClick={() => {
        window?.OneTrust?.ToggleInfoDisplay?.();
      }}
      className={`${footerMenuItem} ${
        region === "us" && privacyChoicesLinkStyles
      }`}
      type="button"
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...otherProps}
    >
      <span>{item.title}</span>
    </button>
  );
};
